import { styled, mq } from 'x'

export const H1 = styled.h1`
  margin: 0;
  color: #fff;
  font-weight: 500;
  font-size: 35px;
  line-height: 42px;
  letter-spacing: 0.05em;
  padding-top: 24px;
  padding-bottom: 30px;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';

  ${mq.below('md')} {
    font-size: 30px;
    padding-bottom: 20px;
    letter-spacing: 0.03em;
  }
`

export const H2 = styled.h2`
  margin: 0;
  color: #fff;
  font-weight: 500;
  font-size: 35px;
  line-height: 42px;
  letter-spacing: 0.05em;
  padding-top: 24px;
  padding-bottom: 30px;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';

  ${mq.below('sm')} {
    font-size: 30px;
    padding-bottom: 20px;
  }
`

export const H3 = styled.h3`
  margin: 0;
  color: #fff;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.05em;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';

  ${mq.below('sm')} {
    font-size: 20px;
  }
`

export const H4 = styled.h4`
  margin: 0 0 10px 0;
  color: #6495ed;
`

export const H5 = styled.h5`
  margin: 0 0 10px 0;
  color: #6495ed;
`

export const H6 = styled.h6`
  margin: 0 0 10px 0;
  color: #6495ed;
`
